/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbProfessionFormateurDto
 */
export interface FcbProfessionFormateurDto {
    /**
     * 
     * @type {number}
     * @memberof FcbProfessionFormateurDto
     */
    idprofession?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbProfessionFormateurDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbProfessionFormateurDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbProfessionFormateurDto interface.
 */
export function instanceOfFcbProfessionFormateurDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbProfessionFormateurDtoFromJSON(json: any): FcbProfessionFormateurDto {
    return FcbProfessionFormateurDtoFromJSONTyped(json, false);
}

export function FcbProfessionFormateurDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbProfessionFormateurDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idprofession': !exists(json, 'idprofession') ? undefined : json['idprofession'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbProfessionFormateurDtoToJSON(value?: FcbProfessionFormateurDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idprofession': value.idprofession,
        'libelle': value.libelle,
        'actif': value.actif,
    };
}

